import React from 'react';

interface SyncStatusBadgeProps {
  syncStatus: boolean;
  deviation?: number;
}

export const SyncStatusBadge: React.FC<SyncStatusBadgeProps> = ({ syncStatus, deviation }) => {
  return (
    <div className="flex items-center gap-2">
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
        syncStatus 
          ? 'bg-green-100 text-green-800' 
          : 'bg-red-100 text-red-800'
      }`}>
        {syncStatus ? '✓' : '✗'}
      </span>
      {deviation !== undefined && (
        <span className="text-xs text-gray-500">
          {deviation.toFixed(1)}%
        </span>
      )}
    </div>
  );
};